import { Button, Text } from '@chakra-ui/react';
import { Modal } from '@time-line/components/common';
import { useCountryModal } from 'hooks/localisation/useCountryModal';
import { DEFAULT_COUNTRY_NAME } from 'lib/constants/siteDefaults';

export const CountryModal = () => {
  const {
    isCountryModalOpen,
    onCloseCountryModal,
    handleCountryModalAccept,
    handleCountryModalStay,
    usersLocale,
  } = useCountryModal();

  return (
    <Modal
      id="country-selector"
      isOpen={isCountryModalOpen}
      onClose={onCloseCountryModal}
      headerIconName="Globe"
      zIndex="countryModal"
    >
      <>
        <Text as="h2" size="title" mb="3xs">
          {`You've reached our store for ${DEFAULT_COUNTRY_NAME}`}
        </Text>
        <Text size="body2" mb="m" color="blackAlpha.700">
          {`This store only ships to addresses in the ${DEFAULT_COUNTRY_NAME}. Did you want to visit
          the store for ${usersLocale?.countryName}? Tell us where you want to go:`}
        </Text>
        <Button width="full" onClick={handleCountryModalAccept} mb="3xs">
          {usersLocale?.countryName}
        </Button>
        <Button width="full" variant="outline" onClick={handleCountryModalStay}>
          Stay here
        </Button>
      </>
    </Modal>
  );
};
